import React, { Component } from "react";

export default class AssociatedPartners extends Component {
  render() {
    return (
      <div className="associated-partners container text-center">
        <h3 className="section-title">OUR ASSOCIATED PARTNERS</h3>
        <div className="underline"></div>

        <div className="row justify-content-center partners-row">
          
          <div className="col-lg-3 col-md-3 col-6 partner-item">
            <div className="partner-circle">
              <img src="/img/partners/711.png" alt="7/11"  />
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-6 partner-item">
            <div className="partner-circle">
              <img src={`${process.env.PUBLIC_URL}/img/partners/howard-johnson.png`} alt="Howard Johnson" />
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-6 partner-item">
            <div className="partner-circle">
              <img src={`${process.env.PUBLIC_URL}/img/partners/ekincare.png`} alt="Ekin Care" />
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-6 partner-item">
            <div className="partner-circle">
              <img src={`${process.env.PUBLIC_URL}/img/partners/connect-heal.png`} alt="Connect and Heal" />
            </div>
          </div>

        </div>
      </div>
    );
  }
}